var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.disconnect}},[_vm._v("\n  Déconnexion\n")])}
var staticRenderFns = []

export { render, staticRenderFns }